const mutationType = {
  SET_CATALOG_LIST: 'setCatalogList',
};

const actionType = {
  SET_CATALOG_LIST: 'setCatalogList',
};

export const state = () => ({
  catalogList: [],
});

function makeTree(nodes, pid) {
  return nodes
    .filter((n) => n.parent_id === pid)
    .reduce(
      (tree, n) => [
        ...tree,
        {
          ...n,
          items: makeTree(nodes, n.id),
        },
      ],
      [],
    );
}

export const mutations = {
  [mutationType.SET_CATALOG_LIST]: (state, catalogList) => {
    state.catalogList = catalogList;
  },
};

export const actions = {
  async [actionType.SET_CATALOG_LIST]({ commit }) {
    try {
      const res = await this.$api.agent.transport
        .get('categories?per-page=999&fields=id,name,parent_id,url,image_id&sort=name')
        .then((res) => res.data);

      if (res.length) {
        commit(mutationType.SET_CATALOG_LIST, res);
      }
      return res;
    } catch (e) {
      console.error('error ', e);
      return [];
    }
  },
};
export const getters = {
  isListsLoaded: ({ catalogList }) => Boolean(
    catalogList.length,
  ),
  catalogList: ({ catalogList }) => makeTree(catalogList, null)?.[0]?.items,
  fullCatalog: ({ catalogList }) => catalogList,
};
